export default __webpack_public_path__ + "static/media/vue.43bd93a8.jpg";